export default __webpack_public_path__ + "static/media/dental_icon.0126b3e2.svg";